// extracted by mini-css-extract-plugin
export default {"recentes":"Recentes_recentes__W8CtE","recentes__titulo":"Recentes_recentes__titulo__Ad1Jm","recentes__subTitle":"Recentes_recentes__subTitle__R4DMN"};